<template>
    <v-dialog v-model="dialog" max-width="450px" v-on-clickaway="onCancel">
        <v-card>
            <v-form ref="form" v-model="valid">
                <v-card-title class="modal-header-container">
                    <p class="modal-header">{{ header }}</p>
                </v-card-title>

                <v-menu class="date-container" ref="menu" lazy v-model="datePicker" transition="scale-transition" offset-y
                    full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px"
                >
                    <v-text-field slot="activator" label="Termination date" v-model="date"
                        prepend-icon="event" readonly :rules="requiredRulesDatePicker"
                    ></v-text-field>
                    <v-date-picker v-model="date" no-title scrollable actions
                        @change="$refs.menu.save(date)"
                    ></v-date-picker>
                </v-menu>

                <v-text-field v-model="value" class="text-area" textarea :rules="requiredRulesTextArea"></v-text-field>
                <v-card-actions>
                    <div class="modal-confirm">
                        <v-btn class="cancel" @click.stop="onCancel">Cancel</v-btn>
                        <v-btn class="confirm error" @click.stop="onConfirm">Save</v-btn>
                    </div>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { directive as onClickaway } from 'vue-clickaway';

    export default {
        name: 'modal-editor',
        directives: {
            onClickaway
        },
        data() {
            return {
                requiredRulesTextArea: [
                    (v) => !!v || 'Enter archivation reason'
                ],
                requiredRulesDatePicker: [
                    (v) => !!v || 'Enter termination date'
                ],
                dialog: true,
                valid: false,
                datePicker: false,
                value: null,
                date: null
            };
        },
        props: ['header'],
        methods: {
            onConfirm() {
                if (this.$refs.form.validate()) {
                    this.$emit('confirm', this.value, this.date);
                }
            },
            onCancel() {
                this.$emit('cancel');
            }
        }
    };
</script>

<style scoped>
    .modal-confirm {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .modal-header {
        font-size: 18px;
    }
    .text-bold {
        font-weight: bold;
    }
    .modal-header {
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-area {
        padding: 0 16px;
    }

    .date-container {
        padding: 0 16px;
    }
    .modal-header-container {
        padding: 16px 16px 0;
    }
</style>

<style>
    .input-group--textarea.error--text .input-group__input {
        border: 2px solid red !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/modal-editor.component.vue